import type { FaireProductEntity } from "../../entity_types/product";

export const p_96gyxuxq2h: FaireProductEntity = {
  token: "p_96gyxuxq2h",
  type: "product",
  name: "Handblown Mexican DOF Glasses - Tamarind",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/5d858b66a41d3a5c2b1c88909f7d08c8d2fb9ed64479af226bf8ba163ec01fc7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3306c97eb58dbef7c2d749c46d73cd97091853860979daaf975b4d04f822a81.jpeg",
    "https://cdn.faire.com/fastly/83d9d3d8802f23d9b903bed3348e5d16ea1be8957cbb72621e567204f9614a9a.jpeg",
    "https://cdn.faire.com/fastly/3aa213a2b6a55ff9ada314cda9f41de4bbdbbc8a67d1175055bf50b51b9458e6.jpeg",
    "https://cdn.faire.com/fastly/76391f37abafbe3292807302d022a3923526e547ce9704d5c85f24721836029c.jpeg",
    "https://cdn.faire.com/fastly/2b61aab9607744f6624aad81dfb7efac0b9b0722f0d3cf153adcf01d0713a421.jpeg",
    "https://cdn.faire.com/fastly/b6c15a39db517c69102890718c2c050b8ec19c97ae43207a20f5406aeac850ee.jpeg",
    "https://cdn.faire.com/fastly/5632faad9392ff8785a7db3919158ddbb9d15fbee48a5690eb286ec41408ad3b.jpeg",
    "https://cdn.faire.com/fastly/99b59aa6d3577407620a827344a454f6ec4905ad9c7cb011c5d3c59432943cad.jpeg",
    "https://cdn.faire.com/fastly/17807ca9fa80c73b561c5bc2ccec6fbeb72e0fbac0486568b366aadac81f60c2.jpeg",
    "https://cdn.faire.com/fastly/5ba3e764a772cbf20a27402a42a873aee039c27a60190d2effe50f4e35b67f0b.jpeg",
  ],
  priceDollars: 8.75,
  description:
    "**Packaged in sets of 4 as shown; 16 single glasses in a master (4 boxes of 4 glasses)**\n\nIntroducing our Handblown Mexican Glasses in Tamarind - the perfect match for simple, understated, and no-fuss drinks. Sustainably handcrafted by our talented glassblowing artisans in Jalisco, Mexico, each glass is meticulously shaped while molten hot, preserving its distinctive character. Available in sets of 4 for both short and highball sizes, because great drinks are meant to be enjoyed together. Elevate your drinking experience with these exquisite handblown glasses. Cheers to sustainability and craftsmanship!\n\nBe sure to check out our entire Tamarind Glassware Collection, including Highball Glasses, Shooter Glasses, Margarita Glasses, and matching Pitcher!\n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nCapacity:\n400ml / 13 oz \n\nDimensions:\nEach Glass - 3.75'' tall x 3'' diameter\n",
  tags: [],
  msrpDollars: 17.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:12.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
